'use strict'

const TYPE_LABELS = {
  dateTime: 'date & time',
  richText: 'rich text',
  oneToOne: 'one to one',
  oneToMany: 'one to many',
  manyToOne: 'many to one',
  manyToMany: 'many to many'
}

function columnTypeLabel (type) {

  if (type == null || type === '') return ''

  const key = String(type)

  if (TYPE_LABELS[key]) return TYPE_LABELS[key]

  return key
}

function showsSeparateId (title, id) {

  if (id == null || String(id).trim() === '') return false

  if (title == null || String(title).trim() === '') return true

  return String(title).trim().toLowerCase() !== String(id).trim().toLowerCase()
}

module.exports = {
  columnTypeLabel,
  showsSeparateId
}
